import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, LineClamp } from '../../../../global/commonStyle';

const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  ${mobile_xl(css`
    gap: var(--space-24);
    margin-top: var(--space-8);
  `)}
`;
const SessionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  h2 {
    margin: var(--space-0);
    color: var(--text-primary);
    ${Typography.heading_md};
  }
  p {
    margin: var(--space-0);
    color: var(--text-secondary);
    ${Typography.body_md};
  }
`;
const Card = styled.div`
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  ${FlexBetween}
  gap: var(--space-20);
  padding: var(--space-10) var(--space-16);
  ${mobile_xl(css`
    gap: var(--space-12);
  `)}
`;
const LeftContent = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;
const ActiveTag = styled.div`
  background: var(--brand-secondary);
  color: var(--brand-primary);
  border-radius: var(--border-radius-6);
  border: 1px solid var(--brand-secondary);
  padding-inline: var(--space-5);
  ${Typography.body_sm_medium};
`;
const Icon = styled.div`
  padding: var(--space-7);
  border: 0.5px solid var(--neutral-secondary);
  background-color: var(--background-tertiary);
  border-radius: var(--border-radius-4);
  ${FlexCenter}
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  h2 {
    margin: var(--space-0);
    color: var(--text-primary);
    ${Typography.body_lg_medium};
  }
  p {
    margin: var(--space-0);
    color: var(--text-secondary);
    ${Typography.body_sm};
  }
  ${mobile_xl(css`
    h2 {
      ${LineClamp(1)}
      word-break: break-all;
    }
  `)}
`;
const SubHeader = styled.div`
  ${FlexBetween}
  gap: var(--space-20);
  h2 {
    margin: var(--space-0);
    color: var(--text-primary);
    ${Typography.heading_md};
  }
`;
const CardSection = styled.div`
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
`;
const Cards = styled.div`
  ${FlexBetween}
  gap: var(--space-20);
  padding: var(--space-10) var(--space-16);
  border-bottom: 0.5px solid var(--border-primary);
  cursor: pointer;
  .revoke-button {
    display: none;
  }
  &:hover {
    background-color: var(--neutral-secondary);
    .revoke-button {
      display: block;
    }
  }
  :last-child {
    border-bottom: none;
    border-radius: var(--border-radius-0) var(--border-radius-0) var(--border-radius-8) var(--border-radius-8);
  }
  :first-child {
    border-radius: var(--border-radius-8) var(--border-radius-8) 0 0;
  }
  ${mobile_xl(css`
    gap: var(--space-12);
  `)}
`;
const Details = styled.div`
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
  p {
    margin: var(--space-0);
    color: var(--text-secondary);
    ${Typography.body_sm};
    white-space: nowrap;
  }
`;
const DotIcon = styled.div`
  padding: var(--space-5);
  ${FlexCenter}
`;
const Dot = styled.div`
  width: 4px;
  height: 4px;
  border-radius: var(--border-radius-full);
  background-color: var(--text-placeholder);
`;

const RevokeIcon = styled.div`
  ${FlexCenter}
  ${mobile_xl(css`
    padding: var(--space-6);
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;
export {
  BottomContent,
  SessionContent,
  Content,
  Card,
  LeftContent,
  ActiveTag,
  Icon,
  TitleSection,
  SubHeader,
  Cards,
  CardSection,
  Details,
  DotIcon,
  Dot,
  RevokeIcon
};
